<template>
  <div class="limit_count">
    <template v-if="listData.length > 0">

      <div v-for="(item,index) in listData" :key="index" :class="item.broadcast_type == 2 ? 'broadcastbbsList':'broadcastotoList'">
        <!-- 论坛-->
        <!-- <div v-if="item.broadcast_type == 2">
          <div class="broadcastbbsListop" v-if="lan == 'ch'">
            <div class="opopic">
              <img
                :src="item.broadcast_logo" style="width: 100%;height: 100%;object-fit: contain;"/>
            </div>
            <div class="opooinfo">
              <div class="opooinfoMain">
                <div class="opooinfoName">{{item.broadcast_name}}</div>
                <div class="opooinfoTime">{{language.time}}:{{item.periodTime}}</div>
              </div>
              <div class="opooinfosm">
                <ul>
                  <li><span style="margin-right:16px;display: inline-block;">{{item.exh_name}}</span></li>
                  <li><span style="margin-right:16px;display: inline-block;">{{item.exh_begtime}}{{language.to}}{{item.exh_endtime}}</span></li>
                </ul>
              </div>
              <div class="opooinfosm">
                <ul>
                  <li><span style="margin-right:16px;display: inline-block;width:54px">{{language.compere}}:</span>{{item.truename}}</li>
                </ul>
              </div>
              <div class="opooinfobt">
                <ul>
                  <li>
                    <span style="margin-right:16px;display: inline-block;width:54px">{{language.guest}}</span>
                    <span class="btname"><span style="margin-left: 14px">{{language.client}}</span>:{{item.user_post_en}}</span>
                  </li>
                </ul>
              </div>

            </div>
          </div>
          <div class="broadcastbbsListop" v-if="lan == 'en'">
            <div class="opopic">
              <img
                :src="item.broadcast_logo" style="width: 100%;height: 100%;object-fit: contain;"/>
            </div>
            <div class="opooinfo">
              <div class="opooinfoMain">
                <div class="opooinfoName">{{item.broadcast_name_en}}</div>
                <div class="opooinfoTime">{{language.time}}:{{item.periodTime}}</div>
              </div>
              <div class="opooinfosm">
                <ul>
                  <li><span style="margin-right:16px;display: inline-block;">{{item.exh_name_en}}</span></li>
                  <li><span style="margin-right:16px;display: inline-block;">{{item.exh_begtime}}{{language.to}}{{item.exh_endtime}}</span></li>
                </ul>
              </div>
              <div class="opooinfosm">
                <ul>
                  <li><span style="margin-right:16px;display: inline-block;width:54px">{{language.compere}}:</span>{{item.truename_en}}</li>
                </ul>
              </div>
              <div class="opooinfobt">
                <ul>
                  <li>
                    <span style="margin-right:16px;display: inline-block;width:54px">{{language.guest}}<span style="margin-left: 14px">{{language.client}}</span>:</span>
                    <span class="btname">{{item.user_post_en}}</span>
                  </li>
                </ul>
              </div>

            </div>
          </div>
          <div class="broadcastbbsListxt">{{item.broadcast_introduce}}</div>
          <div class="broadcastbbsLisBtn">
            <el-button type="primary" @click="handleCancel(item.broadcast_id)">{{language.unfollow}}</el-button>
            <el-button type="primary" @click="handleGoRoom(item.broadcast_id)">{{language.enter}}</el-button>
          </div>
        </div> -->
        <!-- 直播间-->
        <!-- <div v-else> -->
          <div class="broadcastotoListop" v-if="lan == 'ch'">
            <div class="opopic">
              <img
                v-if="item.broadcast_logo"
                :src="item.broadcast_logo+'?imageMogr2/thumbnail/130x130'"
                style="width: 100%;height: 100%;object-fit: contain;"
              />
              <img
                v-else
                src="@/assets/img_default_logo.png"
                style="width: 100%;height: 100%;object-fit: contain;"
              />
            </div>
            <div class="opooinfo">
              <div class="opooinfoName">{{item.broadcast_name || item.broadcast_name_en}}</div>
              <div class="opooinfosm">
                <ul>
                  <li>{{item.exh_name || item.exh_name_en}}</li>
                  <li>{{item.periodTime}}</li>
                </ul>
              </div>
              <div class="opooinfobt">
                <ul>
                  <li class="opooinfobt_info_li" style="width: 150px">
                    <el-tooltip class="item" effect="dark" :content="item.location || item.location_en" placement="top-start">
                      <div class="opooinfobt_info_li">地区:{{item.location || item.location_en}}</div>
                    </el-tooltip>
                  </li>
                  <li class="opooinfobt_info_li" style="width: 190px">
                    <el-tooltip class="item" effect="dark" :content="item.company || item.company_en" placement="top-start">
                      <div class="opooinfobt_info_li">公司:{{item.company || item.company_en}}</div>
                    </el-tooltip>
                  </li>
                  <li class="opooinfobt_info_li" style="width: 150px">
                    <el-tooltip class="item" effect="dark" :content="(item.user_post || item.user_post_en)+'-'+(item.truename || item.truename_en)" placement="top-start">
                      <div class="opooinfobt_info_li">{{item.user_post || item.user_post_en}}-{{item.truename || item.truename_en}}</div>
                    </el-tooltip>
                  </li>
                  <li class="opooinfobt_info_li" style="width: 240px">

                      <div class="opooinfobt_info_li">预约时间:{{item.use_time}}</div>

                  </li>
                  <!-- <li class="opooinfobt_info_li" style="width: 240px">

                    <div class="opooinfobt_info_li">是否达成:{{item.is_success==0?"已达成":"被取消"}}</div>

                  </li> -->
                </ul>
              </div>
            </div>
          </div>

          <div class="broadcastotoListop" v-if="lan == 'en'">
            <div class="opopic">
              <img
                :src="item.broadcast_logo+'?imageMogr2/thumbnail/130x130'"
                style="width: 100%;height: 100%;object-fit: contain;"
              />
            </div>
            <div class="opooinfo">
              <div class="opooinfoName">{{item.broadcast_name_en||item.broadcast_name}}</div>
              <div class="opooinfosm">
                <ul>
                  <li>{{item.exh_name_en || item.exh_name}}</li>
                  <li>{{item.periodTime_en}}</li>
                </ul>
              </div>
              <div class="opooinfobt">
                <ul>
                  <li class="opooinfobt_info_li" style="width: 130px">
                    <el-tooltip class="item" effect="dark" :content="(item.location_en || item.location)" placement="top-start">
                      <div class="opooinfobt_info_li">Region:{{item.location_en || item.location}}</div>
                    </el-tooltip>
                  </li>
                  <li class="opooinfobt_info_li" style="width: 150px">
                    <el-tooltip class="item" effect="dark" :content="(item.company_en || item.company)" placement="top-start">
                      <div class="opooinfobt_info_li">Company:{{item.company_en || item.company}}</div>
                    </el-tooltip>
                  </li>
                  <li class="opooinfobt_info_li" style="width: 130px">
                    <el-tooltip class="item" effect="dark" :content="(item.user_post_en || item.user_post)+'-'+(item.truename_en ||item.truename)" placement="top-start">
                      <div class="opooinfobt_info_li">{{item.user_post_en || item.user_post}}-{{item.truename_en ||item.truename}}</div>
                    </el-tooltip>
                  </li>
                  <li class="opooinfobt_info_li" style="width: 320px">

                      <div class="opooinfobt_info_li">{{language.appointmentTime}}:{{item.use_time}}</div>

                  </li>
                  <!-- <li class="opooinfobt_info_li" style="width: 240px">

                    <div class="opooinfobt_info_li">是否达成:{{item.is_success==0?"已达成":"被取消"}}</div>

                  </li> -->
                </ul>
              </div>
            </div>
          </div>

          <div class="broadcastotoListxt">{{item.broadcast_introduce}}</div>
          <div class="broadcastotoLisBtn">

            <el-tooltip class="item" effect="dark" :content="language.unfollownotes" placement="top">
              <el-button type="primary" @click="handleCancel(item.broadcast_id)">{{language.unfollow}}</el-button>
            </el-tooltip>
            <el-tooltip v-if="item.broadcast_state == 1 || item.broadcast_state == 3" class="item" effect="dark" :content="language.talkBtnnotes" placement="top">
              <!-- @click="handleJoinBro(item.broadcast_id)" -->
              <el-button type="primary" @click="handleGoRoom(item.broadcast_id)">{{language.talkBtn}}</el-button>
            </el-tooltip>
          </div>
        <!-- </div> -->

      </div>
    </template>
    <template v-else>
      <error-card :language="language"/>
    </template>
<!--提示排队弹窗-->
    <line-dialog
      :show.sync="visibleLine"
      :lan="language"
      :waitData="waitData"
      :lanState="lan"
    />
<!--提示弹窗-->
    <download-dialog :show.sync="downloadShow"/>

  </div>
</template>

<script>
  import errorImage from "../../../../assets/error_room.png"
  import errorBBSImage from "../../../../assets/error_forum.png"
  import errorCard from "../../components/errorCard/index"
  import {isEmpty, isInternet} from "../../../../common/validate";
  import {getLiveUrl} from "../../../../api/forum";
  import {roomUrl, windowsGoTo} from "../../../../common/url";
  import Cookie from "../../../../common/cookie";
  import {MessageBox} from 'element-ui';
  import downloadDialog from "../../../../components/DownloadDialog/index"
  import {mapGetters} from "vuex";
  import lineDialog from "../../../../components/LineDialog";
  import {exhibitionEnterLiveRoom} from "@/api/newRequest";


  export default {
    computed: {
      ...mapGetters(["token", "userInfo"])
    },
    components: {
      errorCard,
      downloadDialog,
      lineDialog,
    },
    props: {
      listData: {
        type: Array,
        default: () => []
      },
      language: {
        type: Object,
        default: () => {}
      }
    },
    data(){
      return {
        errorImage,
        errorBBSImage,
        downloadShow: false,
        lan: Cookie.get("lang"),
        waitData: {},
        visibleLine: false
      }
    },
    methods: {
      //进入论坛
      handleGoRoom(id) {
        if (!isInternet()){
          return  this.downloadShow =true;
        }
        const props = {
          token: this.token,
          broadcast_id: id
        }
        getLiveUrl(props).then(res => {
          if (res.type == 11){
          MessageBox({
            title: "",
            message: Cookie.get("lang")=='ch'?res.text:res.text_en,
            confirmButtonText: language().confirm,
            cancelButtonText: language().cancel,
            showCancelButton: false,
            // type: 'success'
          }).then(() => {
            //确认
          }).catch(() => {
            //取消
          });
        } else if (res.type != "1") {
            if (this.lan == "ch") {
              return this.$message.error({message: res.text, offset: 120})
            }
            return this.$message.error({message: res.text_en, offset: 120})
          }
          const data = res.data[0];
          let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
          sessionStorage.setItem('userType', res.prcurl);
          return window.location.href = windowsGoTo() + roomUrl(data, name)
        })
      },
      //进入直播间
      handleJoinBro(id) {
        if (!isInternet()){
          return  this.downloadShow =true;
        }

        const props = {
          // token: this.token,
          // broadcast_id: id,
          client_id: this.$store.state.live.client_id,
        };
        // this.$store
        //   .dispatch("getLiveInfo", props)
        //参展商进入直播间
        exhibitionEnterLiveRoom(`/room/${id}`, props).then((res) => {
          if (res.data.type != 200) {
            return this.$message.error({
              message: res.data.msg,
              offset: 120,
            });
          }
          let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
          return window.location.href = windowsGoTo() + roomUrl(res.data.data, name);
          // return window.open(
          //     windowsGoTo() + roomUrl(res.data.data, this.userInfo.true_name)
          // );
        });
      },
      //取消预约
      handleCancel(id) {
        this.$emit("handleCancel", {id: id})
      }
    }
  }
</script>

<style>
.limit_count {
  min-height: 500px;
}
.limit_count .broadcastotoList {
  width: 100%;
  background: #fff;
  margin-top: 10px;
  box-shadow: 0px 5px 6px rgba(205, 205, 205, 0.7);
  padding: 22px;
  box-sizing: border-box;
}
.limit_count .broadcastbbsList {
  width: 100%;
  background: #fff;
  margin-top: 10px;
  box-shadow: 0 5px 6px rgba(205, 205, 205, 0.7);
  padding: 22px;
  padding-left: 38px;
  box-sizing: border-box;
}
.limit_count .broadcastotoList .broadcastotoListop {
  display: flex;
}
.limit_count .broadcastotoList .opopic {
  width: 130px;
  height: 130px;
}
.limit_count .broadcastotoList .opopic img {
  width: 100%;
  height: 100%;
}
.limit_count .broadcastotoList .opooinfo {
  margin-left: 21px;
}
.limit_count .broadcastotoList .opooinfo .opooinfoName {
  font-size: 20px;
  color: #0f408a;
}
.limit_count .broadcastotoList .opooinfo .opooinfosm,
.limit_count .broadcastotoList .opooinfo .opooinfobt {
  margin: 20px 0;
  font-size: 14px;
  color: #424242;
}
.limit_count .broadcastotoList .opooinfo .opooinfosm ul,
.limit_count .broadcastotoList .opooinfo .opooinfobt ul {
  display: flex;
  align-items: center;
}
.limit_count .broadcastotoList .opooinfo .opooinfosm ul li {
  margin-right: 40px;
}
.limit_count .broadcastotoList .opooinfo .opooinfobt ul li {
  margin-right: 20px;
}
.limit_count .broadcastotoList .broadcastotoListxt {
  font-size: 14px;
  color: #a1a1a1;
  margin: 20px 0;
}

.limit_count .broadcastbbsList .opopic img {
  width: 100%;
  height: 100%;
}
.limit_count .broadcastotoList .broadcastotoLisBtn {
  text-align: right;
}
.limit_count .broadcastotoList .broadcastotoLisBtn button {
  text-align: right;
  width: 100px;
  height: 40px;
  border-radius: 10px;
  border: none;
  padding: 0;
  font-size: 14px;
  text-align: center;
}
.limit_count .broadcastotoList .broadcastotoLisBtn button:nth-of-type(1) {
  background: #003f8f;
}
.limit_count .broadcastotoList .broadcastotoLisBtn button:nth-of-type(2) {
  background: #ff9e00;
}
.opooinfobt_info_li{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap
}


.limit_count .broadcastbbsList .broadcastbbsListop {
  /* display: flex; */
}
.limit_count .broadcastbbsList .opopic {
  width: 386px;
  height: 100px;
  margin: 0 auto;
  margin-bottom: 20px
}
.limit_count .broadcastbbsList .opopic img {
  width: 100%;
  height: 100%;
}
.limit_count .broadcastbbsList .opooinfo {
  margin-left: 21px;
}
.limit_count .broadcastbbsList .opooinfo .opooinfoMain{
  /* display: flex; */
  justify-content: space-between
}
.limit_count .broadcastbbsList .opooinfo .opooinfoMain .opooinfoTime{
  font-size: 16px;
  color: #424242;
  line-height: 37px;
}
.limit_count .broadcastbbsList .opooinfo .opooinfoName {
  font-size: 28px;
  color: #0f408a;
  font-weight: bold
}
.limit_count .broadcastbbsList .opooinfo .opooinfosm{
  margin: 27px 0 17px 0;
  font-size: 14px;
  color: #424242;
}
.limit_count .broadcastbbsList .opooinfo .opooinfobt{
  font-size: 14px;
  color: #424242;
}
.limit_count .broadcastbbsList .opooinfo .opooinfobt .btname{
  margin-right: 40px
}
.limit_count .broadcastbbsList .opooinfo .opooinfosm ul,
.limit_count .broadcastbbsList .opooinfo .opooinfobt ul {
  display: flex;
  align-items: center;
}
.limit_count .broadcastbbsList .opooinfo .opooinfosm ul li {
  margin-right: 40px;
}
.limit_count .broadcastbbsList .opooinfo .opooinfobt ul li {
  margin-right: 20px;
}
.limit_count .broadcastbbsList .broadcastbbsListxt {
  font-size: 14px;
  color: #a1a1a1;
  margin: 20px 0;
  margin-left: 21px
}
.limit_count .broadcastbbsList .broadcastbbsLisBtn {
  text-align: right;
}
.limit_count .broadcastbbsList .broadcastbbsLisBtn button {
  text-align: right;
  width: 100px;
  height: 40px;
  border-radius: 10px;
  border: none;
  padding: 0;
  font-size: 14px;
  text-align: center;
}
.limit_count .broadcastbbsList .broadcastbbsLisBtn button:nth-of-type(1) {
  background: #003f8f;
}
.limit_count .broadcastbbsList .broadcastbbsLisBtn button:nth-of-type(2) {
  background: #ff9e00;
}
</style>
